import { createUserOrgSettingsHooks } from "@/hooks/userOrgSettingsHooks";

export const PROOF_TRIGGERS = [
  "push",
  "opened",
  "agent_decided",
  "manual",
] as const;
export type ProofTrigger = (typeof PROOF_TRIGGERS)[number];

export const PROOF_PUBLISH = ["none", "description", "comment"] as const;
export type ProofPublish = (typeof PROOF_PUBLISH)[number];

export type UserProofSettings = {
  proof_enabled: boolean;
  proof_trigger: ProofTrigger;
  proof_max_rounds: number;
  proof_publish: ProofPublish;
};

export type UserProofSettingsUpdate = Partial<UserProofSettings>;

const hooks = createUserOrgSettingsHooks<UserProofSettings>({
  resource: "user-proof-settings",
  errorMessage: "Failed to update Proof settings",
});

export const useUserProofSettings = hooks.useSettings;
export const useUpdateUserProofSettings = hooks.useUpdateSettings;
